import employeeAppData from './appData';
import employeeBidProfile from './bidProfile';
import employeeBidSelectionTemplate from './bidSelectionTemplate';
import employeeGlobalSetup from './globalSetup';
import employeeBidSelection from '../../store/bidSelection';

export default {
    employeeAppData,
    employeeBidProfile,
    employeeBidSelectionTemplate,
    employeeGlobalSetup,
    employeeBidSelection,
};
